import { Link } from 'react-router-dom';
import React, { Suspense } from 'react';
import UILoader from 'components/UI/Loader/Loader';
import BaseLayout from 'components/BaseLayout/BaseLayout';
import UIPageTitle from 'components/UI/PageTitle/PageTitle';
import DocumentTitle from 'components/DocumentTitle/DocumentTitle';

import './ScreensUserLogin.scss';

const Login = React.lazy(() => import('components/User/Login/Login'));

const cbn = 'login';

function ScreensUserLogin() {
  return (
    <BaseLayout className={`${cbn}__window`}>
      <DocumentTitle>Sign In</DocumentTitle>
      <div className={`${cbn}__wrapper`}>
        <div className={cbn}>
          <UIPageTitle>Sign in</UIPageTitle>
          <Suspense fallback={<UILoader />}>
            <Login />
          </Suspense>
        </div>
        <div className={`${cbn}__register`}>
          <h2 className={`${cbn}__title`}>Not a BEN User?</h2>

          <p>
            <Link to="/user/reset-password">Request login</Link> to get these
            benefits:
          </p>
          <ul className={`${cbn}__list`}>
            <li>Access the hottest placement opportunities across all media</li>
            <li>Discover, plan and track all placement activity 24/7</li>
            <li>
              Measure performance with validated data from top-tier providers
            </li>
            <li>Receive news and information about the BENlabs</li>
          </ul>
        </div>
      </div>
    </BaseLayout>
  );
}

export default ScreensUserLogin;
